module.exports = __webpack_public_path__ + "static/media/senal-memoria.68577c17.svg";